import {observer} from "mobx-react";
import * as React from "react";
import Dropzone from "react-dropzone";
import Icon from "../Icon/Icon";

interface ILocalState {}
interface IProps {
    propertyName: any;
    cb: (params: any) => void;
    store: any
    acceptedFiles: string;
    selectionText:  any;
    onFileUpload: (files: any) => void;
}

@observer
export default class FileInputDropZone extends React.Component<IProps> {
    public state: ILocalState = {};

    public render() {
        const {acceptedFiles} = this.props;
        const pdfContainerClass = acceptedFiles ===  "application/pdf" || "" ? "file-upload-container": " ";
        return (
            <>
                <div className={pdfContainerClass}>
                    {this.renderDrozone()}
                </div>
            </>
        );
    };

    private renderDrozone = () => {
        const {acceptedFiles, selectionText, onFileUpload} = this.props;
        return (
            <Dropzone onDrop={onFileUpload} accept={acceptedFiles}>
                {({getRootProps, getInputProps}) => (
                    <section>
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className="files-container">
                                <div className="text">
                                    <div className="icon-container"><Icon icon={'browse'}/></div>
                                    {selectionText}
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </Dropzone>
        )
    };
}



// WEBPACK FOOTER //
// ./src/components/FormFileInput/FileInputDropZone.tsx